/**
 * Created by razial on 18.09.2026.
 */

Mission.TYPE_BUILDPASS = 15;

Mission.REGISTRATIONS.set(Mission.TYPE_BUILDPASS, () => ({
    ...BaseMissionData(),
    name: "BuildPass",
    view: BuildPassWindow,
    semaphore: Mission.SEMAPHORE_PRIMARY,
    startWindow: BuildPassWindow,
    finishWindow: BuildPassWindow,
    guideWindow: PassRulesOptions,
    logic: PassMissionLogic,
    levels: PassLevelsConfig.buildpass,
    sideBarJson: bundles.sidebar.jsons.buildpass_icon_json,
    lastChanceView: PassLastChanceWindow,
    collectIcon: function () {
        return cleverapps.skins.getSlot("pass_star_png") || bundles.reward_icons_pass.frames.pass_star_png;
    },
    collectItemName: "star",
    duration: "3 days",
    cooldown: "28 days",
    disabledNewMission: true,
    available: cleverapps.config.availables.BUILDPASS_MISSION
}));
